module.exports = __webpack_public_path__ + "static/media/YF105_3.03582ae9.jpg";